import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseFormControl } from '../components/base-form-control/Component.js';

var defaultColors = {"inner":"form-control__inner_1p4j8","disabled":"form-control__disabled_1p4j8","hasError":"form-control__hasError_1p4j8"};
require('./default.mobile.css')

var invertedColors = {"inner":"form-control__inner_174gs","disabled":"form-control__disabled_174gs","hasError":"form-control__hasError_174gs"};
require('./inverted.mobile.css')

var styles = {"above":"form-control__above_ekh6h","sub":"form-control__sub_ekh6h","error":"form-control__error_ekh6h","size-40":"form-control__size-40_ekh6h","inner":"form-control__inner_ekh6h","size-48":"form-control__size-48_ekh6h","size-56":"form-control__size-56_ekh6h","size-64":"form-control__size-64_ekh6h","size-72":"form-control__size-72_ekh6h"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var FormControlMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseFormControl, __assign({}, restProps, { ref: ref, styles: styles, colorStyles: colorStyles }))); });

export { FormControlMobile };
